export default {
  tableHeader: 'Custom fields',
};
